import { state } from '../lib/state.js';
import { listRoutes } from '../services/repository.js';
import { refreshLineManager } from '../services/line-manager.js';

export async function reloadRoutes() {
  state.routes = await listRoutes(state.organizationId);
  await refreshLineManager();
}
